import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    inject,
    input,
    NgZone,
    OnDestroy,
    OnInit,
    signal,
    ViewEncapsulation,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { JoinClassNamesPipe } from '@shared/join/join-class-names.pipe';

@Component({
    selector: 'companyid-locales',
    imports: [DatePipe, JoinClassNamesPipe],
    templateUrl: './locales.component.html',
    styleUrl: './locales.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalesComponent implements OnInit, OnDestroy {
    public showSales = input(false, {
        transform: (value: boolean | '') => value === '' || value,
    });
    public readonly currentTime = signal(new Date());
    public readonly salesEmail = 'sales@companyid.io';

    public locationItems = [
        {
            title: $localize`Bulgaria, Sveti Vlas`,
            timeZone: 'UTC+3',
        },
        {
            title: $localize`Ukraine, Ivano-Frankivsk`,
            timeZone: 'UTC+3',
        },
    ];

    private interval!: NodeJS.Timeout;
    private readonly ngZone = inject(NgZone);

    @HostBinding('class') public readonly class = 'flex flex-col';

    public ngOnInit(): void {
        this.ngZone.runOutsideAngular(() => {
            this.interval = setInterval(() => {
                this.currentTime.set(new Date());
            }, 1000);
        });
    }

    public ngOnDestroy(): void {
        clearInterval(this.interval);
    }
}
